function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 18c0-.509-.127-.988-.35-1.408l3.421-3.956-.707-.707-3.956 3.421A3 3 0 1019 18zm-3-1a1 1 0 110 2 1 1 0 010-2z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.712 5.283a3 3 0 10-5.425 0C7.41 6.531 3 11.751 3 18c0 7.18 5.82 13 13 13s13-5.82 13-13c0-6.25-4.41-11.469-10.288-12.717zM17 4a1 1 0 11-2 0 1 1 0 012 0zm-1 3C9.925 7 5 11.925 5 18s4.925 11 11 11 11-4.925 11-11S22.075 7 16 7z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.06 4.354a.5.5 0 01.708 0l3.535 3.535a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-3.535-3.535a.5.5 0 010-.707l.707-.707z",
  fill: "currentColor"
})));